import React from "react";
import styles from "./InputRangeSelector.module.scss";

type TInputRangeSelector = {
  min: number;
  max: number;
  value: number;
  onChange: (v: number) => void;
  step: number;
};

const InputRangeSelector: React.FC<TInputRangeSelector> = ({
  min,
  max,
  value,
  onChange,
  step,
}) => {
  const increase = () => {
    if (max >= value + step) onChange(value + step);
  };

  const decrease = () => {
    if (min <= value - step) onChange(value - step);
  };

  return (
    <div className={styles.InputRangeSelector}>
      <div
        className={styles.InputRangeSelector_Decrease}
        onClick={decrease}
        data-disabled={value <= min}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
        >
          <path
            d="M19 37C28.9411 37 37 28.9411 37 19C37 9.05887 28.9411 1 19 1C9.05887 1 1 9.05887 1 19C1 28.9411 9.05887 37 19 37Z"
            stroke="#333333"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M27.4852 19H10.5146"
            stroke="#333333"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className={styles.InputRangeSelector_Value}>{value}</div>
      <div
        className={styles.InputRangeSelector_Increase}
        onClick={increase}
        data-disabled={value >= max}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
        >
          <path
            d="M19 37C28.9411 37 37 28.9411 37 19C37 9.05887 28.9411 1 19 1C9.05887 1 1 9.05887 1 19C1 28.9411 9.05887 37 19 37Z"
            stroke="#DEE0E3"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M19.0001 10.5147V27.4853"
            stroke="#DEE0E3"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.4853 19H10.5148"
            stroke="#DEE0E3"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default InputRangeSelector;
